import { render, staticRenderFns } from "./Riddles.vue?vue&type=template&id=27394a9e&scoped=true&"
import script from "./Riddles.vue?vue&type=script&lang=js&"
export * from "./Riddles.vue?vue&type=script&lang=js&"
import style0 from "./Riddles.vue?vue&type=style&index=0&id=27394a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27394a9e",
  null
  
)

export default component.exports